import { _isSupportWebp } from './_isSupportWebp';

/**
 * @description 转成webp格式
 * @param url
 * @returns
 */
export const _transToWebp = (url: string): string => {
  let ret = url;
  // 判断当前浏览器是否支持webp格式的图片
  if (_isSupportWebp()) {
    // 后台页面不用考虑webp的兼容性，统一使用webp后缀，目前堆糖图片附加后缀只有 _jpeg _webp 两个
    if (ret.endsWith('gif_jpeg')) {
      ret = ret.replace(/gif_jpeg$/i, 'gif_webp');
    } else if (!ret.endsWith('gif')) {
      // 如果不是gif，则统一使用 webp 后缀
      ret = ret.replace(/(_jpeg|_webp)$/i, '');
      ret = ret + '_webp';
    }
  } else {
    ret = ret.replace(/_webp$/, '');
  }

  return ret;
};
